import { Trans } from "@lingui/react/macro";

export function ErrorPage(props: { title: string; message: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8">
      <h1 className="text-2xl font-bold">{props.title}</h1>
      <p className="text-muted-foreground">{props.message}</p>
      <a href="/" className="text-primary hover:underline">
        <Trans>Go back to home</Trans>
      </a>
    </div>
  );
}
